import { Card } from 'antd'
import classNames from 'classnames'
import pluralize from 'pluralize'
import React from 'react'
import { I18n } from 'react-redux-i18n'
import { join } from '../../common/util/helper'

class TheatreItem extends React.Component {

  render () {
    const {theatre, selectedTheatre, toggleTheatreFilter} = this.props
    let screenCount = theatre.auditoriums && theatre.auditoriums.length
    return (
      <Card
        className={classNames('theatre-card qw-left-align qw-cursor-pointer qw-border-bottom', {'selected': selectedTheatre})}
        onClick={() => toggleTheatreFilter(theatre)}
        bordered={false}>
        <div className="theatre">
          <p className="theatre-name qw-font-size-body qw-color-text-body qw-line-height-body qw-bold">{theatre.name}</p>
          <div className="chain qw-font-size-small qw-color-text-body qw-line-height-small">
             {screenCount} {pluralize(I18n.t('theatres.screen'), screenCount)}
             {theatre.chain && <span>&nbsp;&bull;&nbsp;</span> }
             {theatre.chain}
          </div>
          <div className="location qw-font-size-x-small qw-font-weight-medium qw-color-text-secondary-heading qw-mt-xx-small">
            {
              join([
                (theatre.address && theatre.address.city),
                (theatre.address && theatre.address.province),
                (theatre.address && theatre.address.country)
              ])
            }
          </div>
        </div>
      </Card>
    )
  }
}

export default TheatreItem



// WEBPACK FOOTER //
// ./src/app/components/theatres/Item.js